module.exports = __webpack_public_path__ + "img/razorpay.12d84617.svg";